import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { sectorRoleOptions } from '../../constants/sector-role-options';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-sectors-filter',
  templateUrl: './sectors-filter.component.html',
  styleUrls: ['./sectors-filter.component.scss'],
  standalone: false,
})
export class SectorsFilterComponent implements OnChanges {
  public isDisabledApplyFilterButton: boolean;

  @Input() stateParams;
  @Input() filter;
  @Input() data;

  public sectorRoleOptions = sectorRoleOptions;

  ngOnChanges() {
    this.checkDisabledApplyFilterButton();
  }

  public onChangeCompanies(companies): void {
    this.filter.onChangeCompanies(companies);
  }

  public handleSectorRoleChange(selectedSectorRole: ISelectOption) {
    this.filter.onChangeSectorRole(selectedSectorRole.value);
  }

  onChangeBranches(branches): void {
    this.filter.onChangeBranches(branches);
  }

  onChangeCities(cities): void {
    this.filter.onChangeCities(cities);
  }

  onChangeSectors(sectors): void {
    this.filter.onChangeSectors(sectors);
  }

  onChangeDistricts(districts): void {
    this.filter.onChangeDistricts(districts);
  }

  onChangeRegions(regions): void {
    this.filter.onChangeRegions(regions);
  }

  onApplyFilter(): void {
    this.filter.onApplyPlotsFilter();
  }

  onResetFilter(): void {
    this.filter.onResetPlotsFilter();
  }

  checkDisabledApplyFilterButton(): boolean {
    const filter = this.filter;
    return (
      filter.sectorsSelected ||
      filter.branchesSelected ||
      filter.citiesSelected ||
      filter.districtsSelected ||
      filter.companiesSelected ||
      filter.regionsSelected ||
      filter.sectorRoleSelected
    );
  }
}
